module.exports = __webpack_public_path__ + "img/ico-soldout.95168f88.svg";